import React from 'react'
import { Typography, Grid, Button, Link, TextField, Paper, Stack } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ReactComponent as IconIdCard } from '../../../icons/idCard.svg';
import colors from '../../colors'
import imageToBase64 from 'image-to-base64/browser';
import { useSelector, useDispatch } from 'react-redux';
import { IndividualOrExpressAccountTypes } from './IndividualOrExpressAccountTypes'
import { setIdExpiryDate, setIdNumber, setIdPictureBase64, setIdPictureExtension, decrementCurrentRegistrationStep, incrementCurrentRegistrationStep, selectRegistrationState, setShouldFourthStepBeSkipped, setUploadedImage } from '../../../features/registration/registrationSlice'
import { useFormik } from 'formik'
import * as yup from 'yup'
import { LocalizationProvider } from '@mui/lab';
import DesktopDatePicker from '@mui/lab/DesktopDatePicker';
import AdapterDateFns from '@mui/lab/AdapterDateFns'
import { texts } from '../../general/texts';
import FacephiFlow from '../facephi/FacephiFlow';
import { selectLoginState } from '../../../features/login/loginSlice';
import moment from 'moment';

const validationSchema = yup.object({
    idNumber: yup
        .string(texts["message-invalid-id-no"])
        //   .matches( /^[a-zA-Z][a-zA-Z0-9]{8}[a-zA-Z]$/, {
        //         message: "Invalid id number",
        //     })
        .required(texts["message-invalid-id-no"]),
    idExpiryDate: yup
        .string(texts["message-invalid-expiry-date"])
        //   .matches(/^[0-9]{2}[\/][0-9]{2}[\/][0-9]{4}$/,{
        //     message:'Data duhet te jete ne formatin DD/MM/YYYY'
        //     })
        .required(texts["message-invalid-expiry-date"])
        .nullable(),
    idBase64: yup
        .string()
        .required(),
    extension: yup
        .string()
        .required()
});



const FourthRegistrationStep = (props) => {
    const dispatch = useDispatch()
    const registrationSliceState = useSelector(selectRegistrationState)
    const loginSlice = useSelector(selectLoginState)
    const formik = useFormik({
        initialValues: {
            idBase64: '',
            idNumber: '',
            idExpiryDate: '',
            extension: ''
        },
        validationSchema: validationSchema,
        onSubmit: values => {
            dispatch(setIdExpiryDate(values.idExpiryDate))
            dispatch(setIdNumber(values.idNumber))
            dispatch(setIdPictureBase64(values.idBase64))
            dispatch(setIdPictureExtension(values.extension))
            dispatch(incrementCurrentRegistrationStep())
        }

    })
    /////////////////DatePicker//////////////////////////

    const [value, setValue] = React.useState(new Date());

    /////////////////////////////////////////////////////

    const uploadImage = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            dispatch(setUploadedImage(URL.createObjectURL(e.target.files[0])))
        }
    };

    const removeUploadedImage = () => {
        dispatch(setUploadedImage(''))
        setUploadedImage('');
        formik.setFieldValue('extension', '')
        formik.setFieldValue('idBase64', '')
    };

    const onBackButtonClick = () => {
        dispatch(setIdExpiryDate(formik.values.idExpiryDate))
        dispatch(setIdNumber(formik.values.idNumber))
        dispatch(setIdPictureBase64(formik.values.idBase64))
        dispatch(setIdPictureExtension(formik.values.extension))
        dispatch(setShouldFourthStepBeSkipped(false))
        dispatch(decrementCurrentRegistrationStep())
    }

    const handleInputChange = (e) => {
        uploadImage(e)
        imageToBase64(URL.createObjectURL(e.target.files[0]))
            .then(
                (response) => {
                    formik.setFieldValue('extension', e.target.files[0].type.split('/')[1])
                    formik.setFieldValue('idBase64', response)
                }
            )
            .catch(
                (error) => { }
            )
    }


    React.useEffect(() => {
        formik.setFieldValue('idBase64', registrationSliceState.idPictureBase64)
        formik.setFieldValue('idNumber', registrationSliceState.idNumber)
        formik.setFieldValue('idExpiryDate', registrationSliceState.idExpiryDate)
        formik.setFieldValue('extension', registrationSliceState.idPictureExtension)
    }, [registrationSliceState.idExpiryDate, registrationSliceState.idNumber, registrationSliceState.idPictureBase64, registrationSliceState.idPictureExtension])

    const parseDate = (input) => {
        const parsedDate = moment(input, 'DD/MM/yyyy');
        const formattedDate = parsedDate.format('MM/DD/YYYY');
        return formattedDate
    }

    const useStyles = makeStyles({
        mainGrid: {
            width: '50%',
            '@media (max-width: 1440px)': { width: '70%' },
            '@media (max-width: 1024px)': { width: '85%' },
            '@media (max-width: 768px)': { width: '80%' },
            '@media (max-width: 425px)': { width: '90%' }
        },
        fieldTitle: {
            color: colors.orange,
            fontSize: '1.2rem',
            fontFamily: 'GerberaMedium',
            textAlign: 'left'
        },
        textField: {
            width: '15vw',
            '@media (max-width: 899px)': { width: '50vw' }
        },
        paper: {
            padding: '6%',
            width: '70%',
            borderRadius: '20px',
            boxShadow: '0 0 15px 5px #E5E7EA',
            '@media (max-width: 1024px )': { width: '100%' },
            '@media (max-width: 899px )': { width: '150%' }
        },
        submitButton: {
            background: colors.gradientOrange,
            color: colors.white,
            width: '12%',
            fontFamily: 'GerberaBold',
            fontSize: '1rem',
            textTransform: 'none',
            '@media (max-width: 899px)': { width: '40%' }
        },
        link: {
            color: colors.orange,
            fontFamily: 'GerberaLight',
            textDecorationColor: colors.orange,
            "&:hover": { textDecorationColor: '#FF8403', color: '#FF8403' }
        },
        paperHeader: {
            color: colors.darkBlue,
            fontSize: '0.5 rem',
            fontFamily: 'GerberaLight'
        },
        uploadButton: {
            color: colors.orange,
            fontFamily: 'GerberaBold',
            "&:hover": { backgroundColor: 'white', color: '#FF8403' }
        }
    })

    const classes = useStyles()

    return (
        <>
            {registrationSliceState.isUpgrading && !loginSlice.isManualRegistration ? (
                <FacephiFlow />
            ) : (!registrationSliceState.shouldFourthStepBeSkipped
                && registrationSliceState.accountType !== 2
                && !registrationSliceState.isUpgrading) ?
                <IndividualOrExpressAccountTypes /> : (<form onSubmit={formik.handleSubmit}>
                    <Grid container justifyContent='center' width={'100%'}>
                        <Grid container className={classes.mainGrid}>
                            <Grid container item md={12} xs={12} justifyContent={'center'} ml={5} >
                                <Grid container item md={6} xs={12} flexDirection='column' justifyContent='flex-start'>
                                    <Grid container item justifyContent='flex-start' mb={2}>
                                        {registrationSliceState.accountType === 2 ?
                                            <Typography className={classes.fieldTitle} variant="h6">{texts["title-registration-idNumber-business"]}</Typography>
                                            :
                                            <Typography className={classes.fieldTitle} variant="h6">{texts["title-registration-idNumber"]}</Typography>
                                        }
                                    </Grid>
                                    <Grid container item justifyContent='flex-start'>
                                        <TextField id='idNumber' name='idNumber' onChange={formik.handleChange} error={formik.touched.idNumber && Boolean(formik.errors.idNumber)} helperText={formik.touched.idNumber && formik.errors.idNumber} value={formik.values.idNumber} color={'warning'} variant="standard"  disabled={!loginSlice.isManualRegistration} className={classes.textField} /></Grid>
                                </Grid>
                                <Grid container item md={6} xs={12} mb={10} flexDirection='column' justifyContent='flex-start'>
                                    <Grid container item justifyContent='flex-start' mb={2}>
                                        {registrationSliceState.accountType === 2 ?
                                            <Typography className={classes.fieldTitle} variant="h6">{texts["title-registration-expiryDate-business"]}</Typography>
                                            :
                                            <Typography className={classes.fieldTitle} variant="h6">{texts["title-registration-expiryDate"]}</Typography>
                                        }
                                    </Grid>
                                    <Grid container item justifyContent='flex-start'>
                                        {/* <TextField id='idExpiryDate' name='idExpiryDate' onChange={formik.handleChange} error={formik.touched.idExpiryDate && Boolean(formik.errors.idExpiryDate)} helperText={formik.touched.idExpiryDate && formik.errors.idExpiryDate} value={formik.values.idExpiryDate} color={'warning'}  placeholder="DD/MM/YYYY" variant="standard" sx={{width:'60%'}}/> */}
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <Stack spacing={3}>
                                                <DesktopDatePicker
                                                    inputFormat="dd/MM/yyyy"
                                                    openTo="day"
                                                    views={['day', 'month', 'year']}
                                                    value={!loginSlice.isManualRegistration ? parseDate(formik.values.idExpiryDate) : formik.values.idExpiryDate}
                                                    onChange={val => { formik.setFieldValue("idExpiryDate", val); }} color={'warning'}
                                                    disabled={!loginSlice.isManualRegistration}
                                                    renderInput={(params) =>
                                                        <TextField variant="standard" id='idExpiryDate' name='idExpiryDate' label='dd/mm/yyyy' color={'warning'} helperText={formik.touched.idExpiryDate && formik.errors.idExpiryDate} className={classes.textField}   {...params} error={formik.touched.idExpiryDate && Boolean(formik.errors.idExpiryDate)} />}
                                                />
                                            </Stack>
                                        </LocalizationProvider>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container item md={12} xs={12} justifyContent={'center'}>
                                {loginSlice.isManualRegistration && (
                                  <Paper elevation={1} className={classes.paper}>
                                  {registrationSliceState.uploadedImage === '' ? (
                                    <Grid container>
                                      <Grid item md={6} sm={12} xs={12}>
                                        <IconIdCard />
                                      </Grid>
                                      <Grid item md={6} sm={12} xs={12} pt={'3%'}>
                                        <Typography className={classes.paperHeader} variant="standard">{texts["prompt-upload-id"]}</Typography>
                                        <Grid item marginTop={3}>
                                          <Grid>
                                            <input accept="image/*" id="upload-company-logo" onChange={handleInputChange} type='file' hidden />
                                            <label htmlFor="upload-company-logo">
                                              <Button className={classes.uploadButton} component="span">
                                                {texts["button-upload"]}
                                              </Button>
                                            </label>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  ) : (
                                    <Grid container item md={12} xs={12} justifyContent={'center'}>
                                      <Grid container item md={6} xs={12} pb={'3%'} justifyContent={'center'}>
                                        <img
                                          style={{ width: "300px", height: '150px', borderRadius: "20px" }}
                                          src={registrationSliceState.uploadedImage}
                                          alt="Thumb"
                                        />
                                      </Grid>
                                      <Grid item md={12} xs={12}>
                                        <Link className={classes.link} component='button' onClick={removeUploadedImage}>{texts["button-delete"]}</Link>
                                      </Grid>
                                    </Grid>
                                  )}
                                </Paper>
                                
                                )}

                                {!loginSlice.isManualRegistration && (
                                    <img
                                        style={{ width: "300px", height: '150px', borderRadius: "20px" }}
                                        src={registrationSliceState.idPictureBase64}
                                        alt="Thumb"
                                    />)}
                            </Grid>
                        </Grid>
                        <Grid item md={12} xs={12} pt={'2%'}>
                            <Button disabled={registrationSliceState.isLoading ? true : false} type='submit' className={classes.submitButton}>{texts["button-continue"]}</Button>
                        </Grid>
                        {registrationSliceState.isUpgrading ? <Grid item md={12} xs={12} pt={'0.8%'}> </Grid> :
                            <Grid item md={12} xs={12} pt={2}>
                                <Link disabled={registrationSliceState.isLoading ? true : false} className={classes.link} onClick={onBackButtonClick} component='button' variant='body2'>{texts["button-back"]}</Link>
                            </Grid>
                        }
                    </Grid>
                </form>
                )}
        </>
    );

}

export default FourthRegistrationStep
